import React, { useState, useRef, useEffect, useContext, BaseSyntheticEvent } from "react";
import { times } from "core/times";
import { createTimeArr } from "core/lib/time-methods";
import { AppContext } from "core/providers/tv-guide.context";

type TimeBarProps = {
  scrollX: number;
  setScrollX: (value: number) => void;
}

const TimeBar = (props: TimeBarProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const timeBar = useRef<any>(null);

  const [timeArr, setTimeArr] = useState<string[]>([]);
  const [scrollX, setScrollX] = useState(0);
  const [grabbing, setGrabbing] = useState(false);

  const appContext = useContext(AppContext);
  const store = appContext.store;

  if (
    timeBar?.current &&
    props.scrollX &&
    props.scrollX !== scrollX
  ) {
    // console.log("TimeBar ScrollTo: " + props.scrollX);
    timeBar.current.scrollTo(props.scrollX, 0, { behavior: "smooth" });
  }

  useEffect(() => {
    const list = createTimeArr(times);
    setTimeArr(list);
  }, []);

  const { hours, minutes } = store.dateTime;
  const hourString = hours.toString();

  const isActive = (time: string, index: number) => {
    const [hr, min] = time.split(":");
    if (hourString !== hr || index > 48) {
      return;
    }

    if (min === "00" && minutes < 30) {
      return true;
    }

    if (min === "30" && minutes > 30) {
      return true;
    }

    return false;
  }

  return (
    <div
      className="time-bar grabbable"
      ref={timeBar}
      id="timeBar"
      onMouseDown={() => {
        if (!grabbing) {
          setGrabbing(true);
        }
      }}
      onMouseMove={(ev) => {
        if (grabbing) {
          timeBar.current.scrollBy(-ev.movementX, -ev.movementY);
        }
      }}
      onMouseLeave={() => {
        if (grabbing) {
          setGrabbing(false);
        }
      }}
      onMouseUp={() => {
        if (grabbing) {
          setGrabbing(false);
        }
      }}
      onScroll={(ev: BaseSyntheticEvent) => {
        setScrollX(ev.target.scrollLeft);
        props.setScrollX(ev.target.scrollLeft);
      }}
    >
      <div className="time-track">
        {timeArr.map((time: string, index: number) => {
          const active = isActive(time, index);

          return (
            <div
              className={`time-chunk ${active ? "highlight" : ""}`}
              key={time + index}
              id={"t-" + index}
            >
              {time}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TimeBar;
